<template>
  <div class="payment-form__btn-wrapper">
    <p v-if="errorsLength > 0" class="cart__btn--errors">
      <ErrorIcon class="cart__btn--error-icon" />
      Please fix {{ errorsLength }} errors before continuing
    </p>
    <p v-if="paymentMethod === 'paypal'" class="cart__btn--notice">
      You will be redirected to PayPal<br />
      to login to your account
    </p>
    <button type="submit" :disabled="errorsLength > 0" class="btn btn--primary">
      Save payment
    </button>
  </div>
</template>

<script>
import ErrorIcon from '@/assets/icons/error.svg'

export default {
  name: 'PaymentFormButton',
  components: {
    ErrorIcon: { ...ErrorIcon, name: 'ErrorIcon' },
  },
  props: {
    paymentMethod: {
      type: String,
      required: true,
    },
    errorsLength: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style></style>
